// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { StoneCategoryTranslationFragmentDoc } from './StoneCategoryTranslation.fragment.generated';
export const StoneCategoryFragmentDoc = gql`
    fragment stoneCategory on StoneCategory {
  systemCode
  translation(locale: $locale) {
    ...stoneCategoryTranslation
  }
}
    ${StoneCategoryTranslationFragmentDoc}`;